import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const DatabaseDownstreamDatasourcesWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DatabaseDownstreamDatasourcesWithoutPersonalSpaceQuery($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  databases(filter: { id: $databaseId }) {
    downstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
